import Service from "../../AuthService";
const ReportSheet = {
    getReportSheet(page) {
        return Service.get("/sheet-report?page="+page);
    },
    showReportSheet(id) {
        return Service.get("/sheet-report/" + id);
    },
    showReason(id) {
        return Service.get("/sheet-report-get?id=" + id);
    },
    updateReportSheet(id, data) {
        return Service.put("/sheet-report/" + id, data);
    },
    createReportSheet(data) {
        return Service.post("/sheet-report", data);
    },
    createNewReportSheet(data) {
        return Service.post("/sheet-report-new", data);
    },
    deleteReportSheet(id) {
        return Service.delete("/sheet-report/" + id);
    },
    searchReportSheet(page,code, date, machine) {
        return Service.post(
            "/search-sheet-report?page=" +
                page+
                "&code=" +
                code +
                "&date=" +
                date +
                "&machine=" +
                machine
        );
    }
};
export default ReportSheet;
